import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RemainingAmountBudgetMap } from '@core/typings/budget.typing';
import { ClientSettingsService } from '@features/client-settings/client-settings.service';
import { TypeaheadSelectOption } from '@yourcause/common/core-forms';

@Component({
  selector: 'gc-budget-fs-typeahead',
  templateUrl: './budget-fs-typeahead.component.html',
  styleUrls: ['./budget-fs-typeahead.component.scss']
})
export class BudgetFsTypeaheadComponent  {
  @Input() disabled = false;
  @Input() controlName = 'budgetIdFundingSource';
  @Input() remainingAmountBudgetMap: RemainingAmountBudgetMap = {};
  @Input() comboId: string; // BudgetID - SourceID
  @Input() budgetFundingSourceOptions: TypeaheadSelectOption[] = [];
  @Output() onBudgetFsChange = new EventEmitter();

  hideFundingSources = this.clientSettingsService.hideFundingSources;

  constructor (
    private clientSettingsService: ClientSettingsService
  ) { }

  _onBudgetFsChange () {
    this.onBudgetFsChange.emit();
  }
}
